export default __webpack_public_path__ + "static/media/Long_arrow.55f196ac.svg";